/**
 * HSFormEvents — bootstrap entry point.
 *
 * Rollup entry for the HSFormEvents bundle (rollup.config.mjs →
 * createJsConfigs). Output lands at dist-js/HSFormEvents.min.js,
 * enqueued globally via the theme's asset registration pipeline.
 *
 * Sub-namespaces:
 *   ThryvHSFormEvents.Registry — GUID → event metadata map
 *   ThryvHSFormEvents.Tracker  — postMessage listener + dataLayer push
 *
 * Debug:
 *   ThryvHSFormEvents.Tracker.debug = true
 */
import Registry from "./Registry.js";
import Tracker from "./Tracker.js";

window.ThryvHSFormEvents = window.ThryvHSFormEvents || {};

// Attach sub-namespaces
window.ThryvHSFormEvents.Registry = Registry;
window.ThryvHSFormEvents.Tracker = Tracker;

// Bootstrap method — runs on DOM ready
window.ThryvHSFormEvents.init = function () {
  this.Tracker.init();
};

DOMReady(function () {
  window.ThryvHSFormEvents.init();
});
